<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="title"
      :isShowModal="isShowModal"
      :canCancel="true"
      @cancel="cancel($event)">
      <article class="container">
        <MessageDetail 
          :selectMessage="selectMessage"
          @clickCloseBtn="clickCloseBtn"/>
      </article>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import MessageDetail from '@/components/organisms/articles/MessageDetail'

export default {
  components: {
    BasicModal,
    MessageDetail
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    selectSeeker: {
      type: Object,
      required: false
    },
    selectMessage: {
      type: Array,
      default: () => []
    },
    keepDropdownOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      if (this.selectMessage.length > 0) {
        const robotName = this.selectMessage[0].name;
        return '会話ロボ名（' + robotName + '）';
      }
      return 'ロボ会話詳細';
    }
  },
  methods: {
    cancel (source = 'manual') {
      // 自動閉じの場合は強制的にドロップダウンを保持
      const shouldKeepDropdown = source === 'auto' ? true : this.keepDropdownOpen
      
      this.$emit('cancel', false, shouldKeepDropdown)
    },
    clickCloseBtn () {
      // 明示的なクリックの場合は従来通り
      this.$emit('cancel', false, this.keepDropdownOpen)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .container {
    padding: 8px;
    height: 600px;
    display: flex;
    align-items: center;
    overflow: auto;
    section {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/modals/ModalMessageDetail.vue